import React from 'react';

const TutorCard = ({ tutor }) => {
  const getBadge = (badgeType) => {
    switch(badgeType) {
      case 'verified':
        return (
          <div className="verified-badge badge-tooltip" title="Verified Tutor">
            <img src="https://cdn-icons-png.flaticon.com/512/10629/10629607.png" alt="Verified Icon" />
          </div>
        );
      case 'premium':
        return (
          <div className="premium-badge badge-tooltip" title="Premium Tutor - Top-rated & Certified">
            <i className="fas fa-crown"></i> PREMIUM
          </div>
        );
      case 'popular':
        return (
          <div className="popular-badge badge-tooltip" title="Popular Tutor - High demand">
            <i className="fas fa-fire"></i> Popular
          </div>
        );
      case 'pending':
        return (
          <>
            <div className="unverified-badge badge-tooltip" title="Pending Verification">
              <i className="fas fa-clock"></i>
            </div>
            <div className="unverified-text-badge badge-tooltip" title="Profile Under Review - Verification in Progress">
              <i className="fas fa-hourglass-half"></i> PENDING
            </div>
          </>
        );
      default:
        return null;
    }
  };

  return (
    <div className="tutor-card">
      <div className="tutor-image-box">
        <img src={tutor.image} alt={tutor.name} />
        <span className="tutor-status" style={{
          backgroundColor: tutor.status === "Busy" ? "var(--accent-color)" : "var(--success-color)"
        }}>{tutor.status}</span>
      </div>
      <div className="tutor-info">
        <div className="tutor-header-row">
          <div className="tutor-name-wrapper">
            <h3 className="tutor-name">{tutor.name}</h3>
            <div className="tutor-badges">
              {tutor.badges.map((badge, index) => (
                <React.Fragment key={index}>
                  {getBadge(badge)}
                </React.Fragment>
              ))}
            </div>
          </div>
          <div className="tutor-rating">
            <i className="fas fa-star"></i> {tutor.rating}
          </div>
        </div>
        <div className="tutor-subject">
          {tutor.subjects.map((subject, index) => (
            <span key={index} className={`subject-with-icon ${subject.className}`}>
              <i className={`${subject.icon} subject-icon`}></i> {subject.name}
            </span>
          ))}
        </div>
        <div className="tutor-meta-grid">
          <div className="tutor-meta">
            <i className="fas fa-map-marker-alt"></i> {tutor.location}
          </div>
          <div className="tutor-meta">
            <i className="fas fa-graduation-cap"></i> {tutor.education}
          </div>
          <div className="tutor-meta">
            <i className="fas fa-briefcase"></i> {tutor.experience}
          </div>
          <div className="tutor-meta">
            <i className="fas fa-clock"></i> {tutor.schedule}
          </div>
        </div>
      </div>
      <div className="tutor-actions">
        <a href={`/tutor/${tutor.id}`} className="btn-profile">View Profile</a>
        <a href={`/messages?tutor=${tutor.id}`} className="btn-contact">Message</a>
      </div>
    </div>
  );
};

export default TutorCard;